export default class ItemReceita {
    cultura = {};
    praga = {};
    produto = {};
    receita = {idReceita: 0};
    localAplicacao = {};
    dose = 0;
    nAplicacoes = 0;
    qtdeAdquirir = 0;
    volumeCalda = 0;
    areaAplicacao = 0;
    descEquipamentoAplicacao = "";
    lote = "";
    descRecomendacoes = "";
    descModoAplicacao = "";
    obs = "";
}
